/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSessionExpired = exports.setCurrentSession = exports.generateNewId = exports.getCurrentSession = void 0;

var uuid_1 = require("uuid");

var brightsmith_core_1 = require("brightsmith-core");

var BRIGHTSMITH_USER_SESSION = 'brightsmith_user_session';
var DEFAULT_TTL = 60 * 30;

exports.getCurrentSession = function () {
  var session = brightsmith_core_1.SessionStorage.getItem(BRIGHTSMITH_USER_SESSION, {
    json: true
  }) || {};
  var ttl = session.ttl || DEFAULT_TTL;

  if (session) {
    var id = session.id,
        lastUpdated = session.lastUpdated;

    if (id && !exports.isSessionExpired(lastUpdated, ttl)) {
      return id;
    }
  }

  return exports.generateNewId(ttl);
};

exports.generateNewId = function (ttl) {
  var id = uuid_1.v4();
  exports.setCurrentSession({
    id: id,
    ttl: ttl,
    lastUpdate: new Date()
  });
  return id;
};

exports.setCurrentSession = function (session) {
  brightsmith_core_1.SessionStorage.setItem(BRIGHTSMITH_USER_SESSION, session, {
    json: true
  });
};

exports.isSessionExpired = function () {
  var lastUpdated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var ttl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TTL;

  if (!ttl) {
    return true;
  }

  return false;
};